export const numDocs = {
  name: 'num',
  category: 'Fraction',
  syntax: ['num(x)'],
  description: 'Get the numerator of a fraction.',
  examples: ['num(fraction(2, 3))', 'num(fraction(5, 8))'],
  seealso: ['den', 'fraction']
}
